import MobileOrderActions from "./mobile-order-actions";
import { useTranslation as useInterfaceTranslation } from "react-i18next";
import useMediaQuery from "Utils/hooks/use-media-query";
import { useState, useRef } from "react";
import { OrderFilterTypes } from "Constants/order";
import { format } from "date-fns";
import { useAppSelector } from "Redux/hooks";

import copy_order from "../../assets/img/ticket__create/copy_order.svg";
import infoIcon from "../../assets/img/save_export/info.svg";
import previewIcon from "../../assets/img/save_export/preview.svg";
import incomingIcon from "../../assets/img/save_export/incoming.svg";

import { Overlay, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./icons.scss";

function OrderTableRow({
  order,
  number,
  mobileFilter = 1,
  onOpenPreviewHandle,
  setIsMouseOver,
  OrderPositionRef,
  setSelectedOrder,
  setIsDataFetched,
  mobileActions,
}: any) {
  const { t: uiT } = useInterfaceTranslation("interface");
  const isMobile = useMediaQuery("(max-width: 991.98px)");

  const rightToLeft = useAppSelector((state) => state.root.rightToLeft);
  const { t } = useTranslation(["common", "newOrder", "measurements"]);
  const [showPrevTooltip, setShowPrevTooltip] = useState(false);
  const [isHovered, setIsHovered] = useState(-1);

  const targetPrev = useRef(null);

  const handleCopyOrderNo = (e: any) => {
    e.stopPropagation();
    if (!order.order_no) return;
    navigator.clipboard.writeText(order.order_no);
  };

  let row = (
    <tr
      className="grid-table-row"
      onMouseEnter={() => {
        setIsHovered(order.id);
        setSelectedOrder(order);
      }}
      onMouseLeave={() => setIsHovered(-1)}
    >
      <td
        onMouseLeave={() => {
          setIsMouseOver(false);
        }}
      >
        <div className="form-check form-check-inline">
          {isHovered === order.id ? (
            <div className="order-dropsdown">
              <img
                src={infoIcon}
                alt={"options Icon"}
                onMouseEnter={(e) => {
                  setIsMouseOver(true);
                }}
                ref={OrderPositionRef}
              />
            </div>
          ) : (
            <label className="form-check-label" htmlFor="inlineCheckbox1">
              {number}
            </label>
          )}
        </div>
      </td>
      <td>
        <p className="para">{format(new Date(order.created), "d.M.yyy")}</p>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <p className="para mb-0">
            <span>{order.order_no && order.order_no.split(".")[0]}</span>.
            {order.order_no && order.order_no.split(".")[1]}
          </p>

          <button
            type="button"
            className={rightToLeft ? "copy-order-table-btn mr-2" : "copy-order-table-btn ml-2"}
            onClick={handleCopyOrderNo}
            title={uiT("Copy order number")}
          >
            <img src={copy_order} alt="copy order" />
          </button>
        </div>
      </td>
      <td className="justify-content-start">
        <div
          className={
            "d-flex align-items-center w-100 " + (rightToLeft ? "ml-2" : "mr-2")
          }
        >
          {/* {!order.is_creater && (
            <img
              src={incomingIcon}
              alt="Incoming Icon"
              className={rightToLeft ? "ml-2" : "mr-2"}
            />
          )} */}
          <p className={"para"}>{order.name}</p>
        </div>
      </td>
      <td>
        <p className="para text-capitalize">{order.site ? order.site : ""}</p>
      </td>
      <td>
        <p className="para text-uppercase">
          {(order.weight / 1000).toFixed(2)}
        </p>
      </td>
      <td>
        <p className="para">
          {order.delivery_date
            ? format(new Date(order.delivery_date), "d.M.yyy")
            : ""}
        </p>
      </td>
        <td style={rightToLeft ? { borderRight: "2px solid #f3f3f3" } : {}}>
        <div className="d-flex iconGroup">
        <button
          className={
            "export__icons " +
            (rightToLeft ? "icons__right" : "icons__left")
          }
          onClick={() => {
            setIsDataFetched(true);
            onOpenPreviewHandle(order.id, false);
          }}
          ref={targetPrev}
          onMouseEnter={() => setShowPrevTooltip(true)}
          onMouseLeave={() => setShowPrevTooltip(false)}
        >
          <img className="m__icon" src={previewIcon} alt="preview icon" />
        </button>

        <Overlay
          target={targetPrev.current}
          show={showPrevTooltip}
          placement="top"
        >
          {(props) => (
            <Tooltip id="overlay-example-2" {...props}>
              {t("Preview", { ns: "common" })}
            </Tooltip>
          )}
        </Overlay>
      </div>
    </td>
    </tr>
  );
  if (isMobile) {
    const orderWeight = (order.order_item || []).length > 0
      ? (
          (order.order_item || []).reduce(
            (pre: number, curr: any) =>
              pre + curr.tool.unit_weight * curr.quantity,
            0
          ) / 1000
        ).toFixed(1)
      : 0;
    const displayedDate =
      mobileFilter === OrderFilterTypes.created ||
      mobileFilter === OrderFilterTypes.sites
        ? order.created
        : order.delivery_date;

    row = (
      <article className="customer-order-card">
        <div className="customer-order-card__header">
          <div>
            <span className="customer-order-card__eyebrow">
              {t("order", { ns: "myOrder" })} #{number}
            </span>
            <strong>{order.order_no || order.business?.name || ""}</strong>
          </div>
          <span className="customer-order-card__date">
            {format(new Date(displayedDate), "d.M.yyy")}
          </span>
        </div>

        <dl className="customer-order-card__details">
          <div>
            <dt>{t("site", { ns: "myOrder" })}</dt>
            <dd>{order.business ? order.business.name : "—"}</dd>
          </div>
          <div>
            <dt>{t("weight", { ns: "myOrder" })}</dt>
            <dd>
              {orderWeight} {t("ton", { ns: "measurements" })}
            </dd>
          </div>
        </dl>

        <div className="customer-order-card__actions">
          <MobileOrderActions label={t("order actions", { ns: "myOrder" })} actions={mobileActions || []} rtl={rightToLeft} />
        </div>
      </article>
    );
  } else {
  }
  return <>{row}</>;
}

export default OrderTableRow;
